module.exports = __webpack_public_path__ + "img/20210720_184935.aeb2dc0f.jpg";